import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { createFileRoute } from "@tanstack/react-router";
import { useState, type ReactElement, type SyntheticEvent } from "react";
import { DangerZonePanel } from "@/features/settings/DangerZonePanel";
import { NotificationPreferencesPanel } from "@/features/settings/NotificationPreferencesPanel";
import { ProfilePanel } from "@/features/settings/ProfilePanel";
import { WebhooksPanel } from "@/features/settings/WebhooksPanel";

const TABS = ["Profile", "Notifications", "Webhooks", "Account"] as const;

interface TabPanelProps {
  index: number;
  value: number;
  children: ReactElement;
}

function TabPanel({ index, value, children }: TabPanelProps): ReactElement | null {
  if (value !== index) return null;
  return (
    <Box role="tabpanel" id={`settings-panel-${index}`} aria-labelledby={`settings-tab-${index}`}>
      {children}
    </Box>
  );
}

function SettingsPage() {
  const [tab, setTab] = useState(0);
  const handleChange = (_event: SyntheticEvent, next: number): void => setTab(next);

  return (
    <Container maxWidth="md" disableGutters>
      <Typography variant="h4" component="h1" gutterBottom>
        Settings
      </Typography>

      <Tabs
        value={tab}
        onChange={handleChange}
        aria-label="Settings sections"
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        {TABS.map((label, index) => (
          <Tab
            key={label}
            label={label}
            id={`settings-tab-${index}`}
            aria-controls={`settings-panel-${index}`}
          />
        ))}
      </Tabs>

      <TabPanel value={tab} index={0}>
        <ProfilePanel />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <NotificationPreferencesPanel />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <WebhooksPanel />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <DangerZonePanel />
      </TabPanel>
    </Container>
  );
}

export const Route = createFileRoute("/_authed/settings")({
  component: SettingsPage,
});
